var t = function (r) {
  return r.number = "number", r.text = "text", r;
}(t || {});
export { t as NumericInputType };